export default class Navigation {

    constructor() {
        this.settings = {
            body: document.querySelector('body'),
            el: document.querySelector('[data-block="main-menu"]'),
        };

        this.bindUIActions();
    }

    bindUIActions() {
        $(document).ready(function() {
            let headerSection = $('.js-header-section');
            let headerHeight = $('header.header').height();
            let $nav = $('a[data-nav]');
            let $navArray = $nav.toArray();

            if (headerSection.hasClass('bg-gl-yellow') || 
                headerSection.hasClass('bg-gl-bright-red') || 
                headerSection.hasClass('bg-gl-light-purple') || 
                headerSection.hasClass('bg-gl-lime-green')) {
                    $navArray.forEach((navItem) => {

                        let navItemVal = navItem.getAttribute('data-nav');
                        
                        navItem.addEventListener('mouseover', () => {
                            let $companyLogo = $('.js-company-logo');
                            $companyLogo.removeClass('invert-color');
        
                            $('.js-header-section').addClass('bg-white');
                            let $menuLinks = $('.js-menu-link');
                            let $menuLinksArray = $menuLinks.toArray();
                            let $singleMenuLinks = $('.js-single-menu-link');
                            let $singleMenuLinksArray = $singleMenuLinks.toArray();

                            $singleMenuLinksArray.forEach((link) => {
                                link.style.color = '#16213e';
                            });

                            $menuLinksArray.forEach((link) => {
                                link.style.color = '#16213e';
                            });
        
                            navItem.style.color = '#00b3d5';
        
                            let $navChildren = $('div[data-nav-child]');
                            let $navChildrenArray = $navChildren.toArray();
        
                            $navChildrenArray.forEach((navChild) => {
        
                                if (navChild.getAttribute('data-nav-child') === navItemVal) {
                                    navChild.style.height = 'max-content';
                                    navChild.style.overflowY = 'auto';
                                    navChild.style.top = headerHeight + 'px';
                                    navChild.style.maxHeight = 'calc(100vh - ' + headerHeight + 'px)';
                                    navChild.classList.add('shadow-lg');
                                } else {
                                    navChild.style.height = '0';
                                    navChild.style.overflowY = 'hidden';
                                    navChild.classList.remove('shadow-lg');
                                }
        
                                navChild.addEventListener('mouseleave', () => {
                                    $('.js-header-section').removeClass('bg-white');
                                    navChild.style.height = '0';
                                    navChild.style.overflowY = 'hidden';
        
                                    $menuLinksArray.forEach((link) => {
                                        link.style.color = '#FFFFFF';
                                    });

                                    $singleMenuLinksArray.forEach((link) => {
                                        link.style.color = '#FFFFFF';
                                    });
                                });
                            });
        
                        });
        
                    });

                    headerSection.mouseleave(() => {
                        let $companyLogo = $('.js-company-logo');
                        $companyLogo.addClass('invert-color');
                    });
                } else {
                    $navArray.forEach((navItem) => {

                        let navItemVal = navItem.getAttribute('data-nav');
        
                        navItem.addEventListener('mouseover', () => {
        
                            $('.js-header-section').addClass('bg-white');
                            let $menuLinks = $('.js-menu-link');
                            let $menuLinksArray = $menuLinks.toArray();
        
                            $menuLinksArray.forEach((link) => {
                                link.style.color = '#16213e';
                            });
        
                            navItem.style.color = '#00b3d5';
        
                            let $navChildren = $('div[data-nav-child]');
                            let $navChildrenArray = $navChildren.toArray();
        
                            $navChildrenArray.forEach((navChild) => {
        
                                if (navChild.getAttribute('data-nav-child') === navItemVal) {
                                    navChild.style.height = 'max-content';
                                    navChild.style.overflowY = 'auto';
                                    navChild.style.top = headerHeight + 'px';
                                    navChild.style.maxHeight = 'calc(100vh - ' + headerHeight + 'px)';
                                    navChild.classList.add('shadow-lg');
                                } else {
                                    navChild.style.height = '0';
                                    navChild.style.overflowY = 'hidden';
                                    navChild.classList.remove('shadow-lg');
                                }
        
                                navChild.addEventListener('mouseleave', () => {
                                    $('.js-header-section').removeClass('bg-white');
                                    navChild.style.height = '0';
                                    navChild.style.overflowY = 'hidden';
        
                                    $menuLinksArray.forEach((link) => {
                                        link.style.color = '#16213e';
                                    });
                                });
                            });
        
                        });
        
                    });
                }

            //Mobile Menu

            let $navMobile = $('a[data-nav-mobile]');
            let $navArrayMobile = $navMobile.toArray();

            $navArrayMobile.forEach((navItem) => {

                let navItemVal = navItem.getAttribute('data-nav-mobile');

                navItem.addEventListener('click', () => {
                    let $nav = $('div[data-nav-child-mobile]');
                    let $navArray = $nav.toArray();

                    navItem.classList.toggle('active');

                    $navArray.forEach((navChild) => {
                        if (navChild.getAttribute('data-nav-child-mobile') === navItemVal) {
                            navChild.classList.toggle('max-h-0');
                            navChild.classList.toggle('overflow-hidden');
                        }
                    });

                });

            });
        });
    }
};

new Navigation();